import { Grid, Typography } from "@mui/material";
import React from "react";
import AssessmentGradingForm from "../../components/Metrics/AssessmentGradingForm";

const AssessmentGradingPage: React.FC = () => {
  return (
    <div className="assessmentListPage">
      <Grid container direction="column">
        <Typography variant="h4" fontWeight="bold" sx={{ fontFamily: "inherit", marginBottom: '0.5rem', marginTop: '0.5rem' }}>Grade Asessments</Typography>
        <AssessmentGradingForm />
      </Grid>
    </div>
  )
}

export default AssessmentGradingPage